/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NotificationBellIcon16Light = forwardRef('NotificationBellIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8 1a5 5 0 0 0-5 5v2.862l-1.429 2.38A.5.5 0 0 0 2 12h4v.5a2 2 0 1 0 4 0V12h4a.5.5 0 0 0 .429-.757L13 8.862V6a5 5 0 0 0-5-5ZM4 6a4 4 0 1 1 8 0v3a.5.5 0 0 0 .071.257L13.117 11H2.883L3.93 9.257A.5.5 0 0 0 4 9V6Zm5 6H7v.5a1 1 0 1 0 2 0V12Z" })));
});
